import { defineComponent, onMounted } from 'vue';
import ScholarshipEditor from './pages/scholarship-editor.vue';
import ScholarshipOverview from './pages/scholarship-overview.vue';
import AppCode from './app.class';

export default defineComponent({
	props: {
		page: String,
	},
	components: {
		ScholarshipEditor,
		ScholarshipOverview,
	},
	setup: (props) => {
		const code = new AppCode(props.page);

		onMounted(() => code.mounted());

		return {
			...code,
		};
	},
});
